// French legal templates adapted to a marketplace.
// IMPORTANT: à faire valider par un avocat avant le lancement réel.
const COMPANY = {
  name: "EventMarket Pro",
  legalName: "SAVEURS NORMANDES",
  legalForm: "Société par actions simplifiée (SAS)",
  capital: "2 000 €",
  siren: "990 061 350",
  siret: "990 061 350 00015",
  rcs: "RCS Bernay 990 061 350",
  naf: "47.27H — Commerce de détail d'épicerie et autres produits alimentaires",
  vat: "FR24 990 061 350",
  address: "4 rue de la Laiterie, 27400 Louviers, France",
  phone: "06 65 02 87 00",
  email: "hello@eventmarketpro.fr",
  dpoEmail: "dpo@eventmarketpro.fr",
  publisher: "Eric Awono",
  host: "Emergent — https://emergent.sh",
  hostAddress: "Information disponible sur https://emergent.sh",
  domain: "eventmarketpro.fr",
  mediator: `Médiateur retenu : <strong>CM2C — Centre de la Médiation de la Consommation de Conciliateurs de Justice</strong>, 14 rue Saint-Jean, 75017 Paris — <a href="https://cm2c.net" target="_blank" rel="noopener noreferrer">cm2c.net</a> — <a href="mailto:cm2c@cm2c.net">cm2c@cm2c.net</a>.<br/><em>L'adhésion de SAVEURS NORMANDES est en cours de finalisation.</em><br/><br/>La procédure interne de traitement des réclamations est <a href="/api/docs/complaints-procedure.pdf" target="_blank" rel="noopener noreferrer">disponible en téléchargement PDF</a>.`,
};

export const LEGAL_PAGES = {
  mentions: {
    slug: "mentions",
    eyebrow: "Information légale",
    title: "Mentions légales",
    updated: "Janvier 2026",
    sections: [
      {
        h: "1. Éditeur du site",
        p: `Le site <strong>${COMPANY.name}</strong> (${COMPANY.domain}) est édité par la société <strong>${COMPANY.legalName}</strong>, ${COMPANY.legalForm} au capital de ${COMPANY.capital}.<br/><br/>SIREN : ${COMPANY.siren}<br/>SIRET du siège : ${COMPANY.siret}<br/>${COMPANY.rcs}<br/>Code APE : ${COMPANY.naf}<br/>N° TVA intracommunautaire : ${COMPANY.vat}<br/><br/>Siège social : ${COMPANY.address}<br/>Téléphone : ${COMPANY.phone}<br/>Email : <a href="mailto:${COMPANY.email}">${COMPANY.email}</a>`,
      },
      {
        h: "2. Directeur de la publication",
        p: `${COMPANY.publisher}, en sa qualité de représentant légal de ${COMPANY.legalName}.`,
      },
      {
        h: "3. Hébergement",
        p: `Le site est hébergé par <strong>${COMPANY.host}</strong>.<br/>Adresse : ${COMPANY.hostAddress}`,
      },
      {
        h: "4. Propriété intellectuelle",
        p: `L'ensemble du contenu de ce site (textes, photographies, logo, charte graphique, code source) est la propriété exclusive de ${COMPANY.legalName} ou de ses utilisateurs ayant consenti à publier sur la plateforme. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable, est strictement interdite et constitue une contrefaçon (art. L.335-2 du Code de la propriété intellectuelle).`,
      },
      {
        h: "5. Crédits photographiques",
        p: `Les photographies illustrant le site proviennent soit de la base éditoriale Unsplash (licence libre), soit des utilisateurs ayant publié leur propre contenu via la plateforme.`,
      },
      {
        h: "6. Contact",
        p: `Pour toute demande d'information : <a href="mailto:${COMPANY.email}">${COMPANY.email}</a>`,
      },
    ],
  },

  cgu: {
    slug: "cgu",
    eyebrow: "Conditions générales",
    title: "Conditions générales d'utilisation",
    updated: "Janvier 2026",
    sections: [
      {
        h: "Préambule",
        p: `Les présentes Conditions Générales d'Utilisation (« CGU ») régissent l'accès et l'utilisation de la plateforme ${COMPANY.name} (« la Plateforme »), service en ligne édité par ${COMPANY.legalName}. Toute inscription emporte acceptation pleine et entière des CGU.`,
      },
      {
        h: "1. Objet",
        p: `La Plateforme est une marketplace mettant en relation des organisateurs d'événements (marchés, salons, foires, festivals), des propriétaires de lieux, des prestataires de services événementiels, des exposants et des visiteurs. ${COMPANY.legalName} n'est pas partie aux transactions conclues entre utilisateurs et n'agit qu'en qualité d'intermédiaire technique.`,
      },
      {
        h: "2. Inscription & comptes",
        p: `L'inscription est gratuite et ouverte à toute personne physique majeure ou morale. L'utilisateur garantit l'exactitude des informations fournies. Six rôles sont disponibles : Visiteur, Organisateur, Exposant, Propriétaire de lieu, Prestataire, Administrateur. Un compte Visiteur peut être faire évoluer vers un rôle Producteur depuis l'espace profil. L'utilisateur est seul responsable de la confidentialité de ses identifiants.`,
      },
      {
        h: "3. Contenu publié",
        p: `Les utilisateurs sont seuls responsables des contenus qu'ils publient (descriptions, photographies, prix, avis). Ils garantissent disposer des droits nécessaires et ne pas porter atteinte aux droits de tiers. ${COMPANY.legalName} se réserve le droit de modérer, modifier ou supprimer tout contenu illicite, trompeur, contraire aux bonnes mœurs ou portant atteinte à l'image de la Plateforme.`,
      },
      {
        h: "4. Avis & signalements",
        p: `Tout utilisateur authentifié peut publier un avis ou signaler un contenu inapproprié. Les avis doivent rester sincères, factuels et respectueux. Les signalements sont traités par l'équipe modération sous 72 heures ouvrées.`,
      },
      {
        h: "5. Suspension & résiliation",
        p: `${COMPANY.legalName} peut suspendre ou clôturer tout compte en cas de manquement aux CGU, de fraude, de paiement contesté ou de comportement abusif. L'utilisateur peut clôturer son compte à tout moment depuis son espace profil ou en contactant le support.`,
      },
      {
        h: "6. Responsabilité",
        p: `${COMPANY.name} fournit la Plateforme « en l'état » et met tout en œuvre pour assurer sa disponibilité. ${COMPANY.legalName} ne garantit pas l'absence d'interruption, ni la qualité des prestations effectuées entre utilisateurs. Sa responsabilité est limitée aux dommages directs, à l'exclusion des préjudices indirects.`,
      },
      {
        h: "7. Droit applicable",
        p: `Les présentes CGU sont régies par le droit français. Tout litige sera soumis à la compétence exclusive des tribunaux du ressort de la Cour d'appel de Paris, sauf disposition d'ordre public contraire.`,
      },
    ],
  },

  cgv: {
    slug: "cgv",
    eyebrow: "Conditions générales",
    title: "Conditions générales de vente",
    updated: "Janvier 2026",
    sections: [
      {
        h: "1. Objet",
        p: `Les présentes Conditions Générales de Vente (« CGV ») s'appliquent à toute transaction conclue via la Plateforme ${COMPANY.name} entre un Vendeur (organisateur, propriétaire de lieu, prestataire) et un Acheteur (exposant, organisateur, visiteur).`,
      },
      {
        h: "2. Prestations vendues",
        p: `Stands d'événements, locations de lieux journaliers, prestations de service événementielles (DJ, sécurité, food-truck, son, lumière, animation, etc.), et achats de boosts régionaux (mises en avant payantes des annonces).`,
      },
      {
        h: "3. Prix & paiement",
        p: `Les prix sont affichés en euros toutes taxes comprises. Le paiement s'effectue par carte bancaire via le prestataire <strong>Stripe</strong> en mode sécurisé (3D Secure). ${COMPANY.legalName} prélève une commission de <strong>20 %</strong> du montant brut. Le solde (80 %) est reversé au Vendeur sur son compte Stripe Connect dans un délai de 2 à 7 jours ouvrés après confirmation du paiement.`,
      },
      {
        h: "4. Facture",
        p: `Une facture PDF est mise à disposition de l'Acheteur et du Vendeur dans leur espace personnel dès confirmation du paiement (rubrique « Mes réservations » > téléchargement).`,
      },
      {
        h: "5. Droit de rétractation",
        p: `Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux prestations de services pleinement exécutées ni aux services de loisirs à date ou période déterminée (événements, locations événementielles).<br/><br/>En cas d'annulation par le Vendeur, l'Acheteur est intégralement remboursé sous 14 jours.`,
      },
      {
        h: "6. Garanties & responsabilités",
        p: `Le Vendeur s'engage à livrer la prestation conformément au descriptif. En cas de litige, ${COMPANY.legalName} peut intervenir comme médiateur, sans pour autant être partie au contrat de vente. La responsabilité de la Plateforme se limite au bon fonctionnement du service technique et au traitement des paiements.`,
      },
      {
        h: "7. Médiation de la consommation",
        p: `En cas de litige non résolu amiablement, l'Acheteur consommateur peut recourir à un médiateur de la consommation agréé. ${COMPANY.mediator}<br/><br/>L'Acheteur peut également utiliser la plateforme européenne de règlement en ligne des litiges (RLL) : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">ec.europa.eu/consumers/odr</a>.`,
      },
      {
        h: "8. Droit applicable",
        p: `Les présentes CGV sont régies par le droit français. Tout litige sera soumis aux tribunaux français compétents.`,
      },
    ],
  },

  confidentialite: {
    slug: "confidentialite",
    eyebrow: "Conformité RGPD",
    title: "Politique de confidentialité",
    updated: "Janvier 2026",
    sections: [
      {
        h: "Préambule",
        p: `${COMPANY.legalName}, en sa qualité de responsable de traitement, attache une importance particulière à la protection de vos données personnelles. La présente politique précise les modalités de collecte et de traitement conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.`,
      },
      {
        h: "1. Données collectées",
        p: `Selon votre usage, nous collectons : <br/>• <strong>Identité</strong> : nom, prénom, email, photo de profil, société, site web<br/>• <strong>Compte</strong> : mot de passe (hashé bcrypt), rôle, préférences email<br/>• <strong>Publications</strong> : événements, lieux, prestations, avis<br/>• <strong>Paiement</strong> : aucune donnée bancaire stockée (déléguée à Stripe, PCI-DSS niveau 1)<br/>• <strong>Usage</strong> : pages vues, logs techniques, adresse IP partielle`,
      },
      {
        h: "2. Finalités du traitement",
        p: `• Fournir la Plateforme et gérer votre compte (base légale : exécution du contrat)<br/>• Traiter les paiements et émettre les factures (base légale : exécution du contrat + obligation légale)<br/>• Envoyer des emails transactionnels (inscription, réservation, signalement) (base légale : intérêt légitime)<br/>• Modérer le contenu et prévenir la fraude (base légale : intérêt légitime)<br/>• Envoyer des sélections éditoriales mensuelles (base légale : consentement, désinscription en 1 clic)`,
      },
      {
        h: "3. Durée de conservation",
        p: `• Données de compte : 3 ans après dernière connexion, puis suppression automatique<br/>• Factures et données comptables : 10 ans (obligation légale, art. L123-22 Code de commerce)<br/>• Logs techniques : 12 mois<br/>• Données de paiement : conservées par Stripe selon leur politique`,
      },
      {
        h: "4. Destinataires",
        p: `Vos données sont accessibles aux équipes internes habilitées et à nos sous-traitants techniques : <strong>Stripe</strong> (paiement), <strong>Resend</strong> (envoi d'emails, domaine vérifié), <strong>MongoDB Atlas</strong> (hébergement base de données, UE), <strong>OpenStreetMap/Nominatim</strong> (géocodage). Aucune donnée n'est revendue à des tiers commerciaux.`,
      },
      {
        h: "5. Transferts hors UE",
        p: `Les données sont hébergées dans l'Union Européenne. Les rares transferts (ex. : Stripe US) s'appuient sur les clauses contractuelles types de la Commission européenne.`,
      },
      {
        h: "6. Vos droits RGPD",
        p: `Vous disposez à tout moment des droits suivants :<br/>• <strong>Accès</strong> et <strong>portabilité</strong> de vos données<br/>• <strong>Rectification</strong> et <strong>effacement</strong><br/>• <strong>Limitation</strong> et <strong>opposition</strong> au traitement<br/>• <strong>Retrait du consentement</strong> (notamment pour les emails marketing, en 1 clic depuis chaque message)<br/><br/>Pour exercer ces droits, contactez notre Délégué à la Protection des Données : <a href="mailto:${COMPANY.dpoEmail}">${COMPANY.dpoEmail}</a><br/><br/>Vous pouvez également déposer une réclamation auprès de la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.`,
      },
      {
        h: "7. Cookies",
        p: `Nous utilisons uniquement des cookies techniques nécessaires au fonctionnement (session, authentification) — sans consentement requis selon la recommandation CNIL — et, sur consentement explicite, un outil d'analyse anonyme sans cookies tiers (Umami, open-source). Aucun cookie publicitaire ou tiers de tracking n'est déposé.`,
      },
      {
        h: "8. Sécurité",
        p: `Mots de passe hashés via bcrypt, sessions JWT en cookies HttpOnly+SameSite, communications chiffrées TLS 1.3, sauvegardes quotidiennes chiffrées avec rétention 30 jours, audits de sécurité annuels.`,
      },
    ],
  },
};
